import { useEffect, useState } from "react";
import { BreathAPIs } from "../../APIs/BreathAPIs";

import { Button, Timeline, Table, Modal, Drawer, Input, Select } from "antd";
import { toast, ToastContainer } from "react-toastify";
import { Container } from "react-bootstrap";
import { TbProgressBolt } from "react-icons/tb";
import { IoPeople } from "react-icons/io5";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SiteTrackerDetails from "./SiteTrackerDetails";
import EditableStatusCell from "./Components/EditableStatusCell";
import styles from "./style.module.css";

import {
  HomeOutlined,
  LoadingOutlined,
  SettingFilled,
  SmileOutlined,
  SyncOutlined,
} from '@ant-design/icons';
const SiteInstallAndOnboarding = ({userGroups}) => {
  const [pagination, setPagination] = useState({
    total: 0,
    current: 1,
    pageSize: 10,
    totalPages: 0,
  });
  const [siteTrackerData, setSiteTrackerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSiteTrackerDetails, setShowSiteTrackerDetails] = useState(false);
  const [selectedSite, setSelectedSite] = useState(null);
  const [autoSaveInprogress, setAutoSaveInprogress] = useState(false);
  const [isApprover, setIsApprover] = useState(false)
  const [isApproverView, setIsApproverView] = useState(false)
  const [searchQuery, setSearchQuery] = useState(null);
  const [filters, setfilters] = useState(null)
  const [isSyncLoading, setIsSyncLoading] = useState(false);

  // console.log("userGroups prop: ", userGroups);
    useEffect(() => {
      if(userGroups){
        userGroups.filter((grps) => {
        let permissions = JSON.parse(grps.permissions);
        if (permissions?.siteOnboardingApprover && permissions?.siteOnboardingApprover === "yes") {
          setIsApprover(true);
        }
      });
      }
    }, []);

  const updateTrackerData = async(dataChanged, trackerId, sectionChanged = null)=>{
          try {
              setAutoSaveInprogress(true);
              let res = await BreathAPIs.updateSiteTrackerData(dataChanged, trackerId, sectionChanged);
              // console.log("response after updating tracker details", res);
              setTimeout(() => {
                setAutoSaveInprogress(false);
              }, 1000);
          } catch (error) {
              setTimeout(() => {
                setAutoSaveInprogress(false);
              }, 1000);
              console.log("Error updating tracker details", error);
          }
      }

  const handleSearch = async() => {
    // if(isPendingDealsView){
    //   getPendingDeals(1, pagination.pageSize);
    // }else if(isApproverView){
    //   getAllDeals(true, 1, pagination.pageSize);
    // }else{
    //   getAllDeals(false, 1, pagination.pageSize);
    // }
    // console.log("searchQuery: ", searchQuery);
    try{
      setIsLoading(true);
    let res = isApproverView ? await BreathAPIs.fetchApprovePendingSites(1, pagination.pageSize, filters, searchQuery):  
              await BreathAPIs.getSiteTrackerData(1, pagination.pageSize, filters, searchQuery);

    if (res.status === 200) {
        setPagination({
          total: res.data.pagination.total,
          current: res.data.pagination.current,
          pageSize: res.data.pagination.pageSize,
          totalPages: res.data.pagination.totalPages,
        });
        setSiteTrackerData(res.data.sitesData);
      } else {
        toast.error("error in fetching data");
      }
      setIsLoading(false);
    }catch(error){
      setIsLoading(false);
      console.log("Error searching tracker data", error.message);
      toast.error(error.message);
    }
    
  }

  const fetchTrackerData = async (current = 1, pageSize = 10) => {
    // console.log("fetching tracker data ")
    // console.log("isApprover view: ", isApproverView)
    try {
      setIsLoading(true);
      let res = isApproverView ? await BreathAPIs.fetchApprovePendingSites(current, pageSize, filters, searchQuery):  await BreathAPIs.getSiteTrackerData(current, pageSize, filters, searchQuery);
      // console.log("response for tracker: ", res.data)
      if (res.status === 200) {
        setPagination({
          total: res.data.pagination.total,
          current: res.data.pagination.current,
          pageSize: res.data.pagination.pageSize,
          totalPages: res.data.pagination.totalPages,
        });
        setSiteTrackerData(res.data.sitesData);
      } else {
        toast.error("error in fetching data");
      }
      setIsLoading(false);
      // console.log("response for site Tracker", res);
    } catch (error) {
      console.log("error in fetching tracker data; ", error.message);
      toast.error(error.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTrackerData();
  }, [showSiteTrackerDetails, isApproverView]);

  const syncSites = async () => {
    try {
      setIsSyncLoading(true);
      let response = await BreathAPIs.syncData();
      if (response.status === 200) {
        toast.success("Sites synced.");
        fetchTrackerData();
      } else {
        toast.error("Error syncing sites");
      }
    } catch (error) {
      console.log("error in syncing sites: ", error.message);
      toast.error(error.message);
    } finally {
      setIsSyncLoading(false);
    }
  };

  const handleTableChange = (pagination) => {
    const { current, pageSize } = pagination;
    fetchTrackerData(current, pageSize);
  };
  //   const [showLocationDetails, setShowLocationDetails] = useState(false);
  //   const handleClick = () => {
  //     setReverse(!reverse);
  //   };

  const handleStatusChange = async (id, dataIndex, newValue) => {
      await updateTrackerData({ [dataIndex]: newValue }, id, dataIndex);
      setSiteTrackerData(prevData => {
      return prevData.map(item => {
        if (item._id === id) {
          return {
            ...item,
            [dataIndex]: newValue, 
          };
        }
        return item;
      });
    });
    }

  const column = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      render: (value, record) => (
        record.status !== "Not started" ? 
        <Button
          type="link"
          style={{
            whiteSpace: "normal",
          }}
          onClick={() => {
            setSelectedSite(record);
            setShowSiteTrackerDetails(true);
          }}
        >
          {value}
        </Button> : 
        

        <Button     
          type="link"
          style={{
            whiteSpace: "normal",
          }}
          // onClick={() => {
          //   setSelectedSite(record);
          //   setShowSiteTrackerDetails(true);
          // }}
        >
          {value}
        </Button>

      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      render: (value, record) => value || "N/A",
    },
    {
      title: (
        <span>
          <TbProgressBolt /> Status
        </span>
      ),
      dataIndex: "status",
      key: "status",
      showSorterTooltip: { target: "full-header" },
      // filters: [
      //   { text: "Not started", value: "Not started" },
      //   { text: "In Progress", value: "In Progress" },
      //   { text: "Pre Live", value: "Pre Live" },
      //   { text: "Live", value: "Live" },
      // ],
      // onFilter: (value, record) => record.status === value,
      render: (value, record) => (<EditableStatusCell value={value} record={record} dataIndex="status" onStatusChange={handleStatusChange}/>),
    },
    {
      title: (
        <span>
          <IoPeople /> Sales POC{" "}
        </span>
      ),
      // dataIndex: ["salesPoc", "firstName"],
      key: ["salesPoc", "email"],
      render: (_, record) => {
        const first = record.salesPoc?.firstName || "";
        const last = record.salesPoc?.lastName || "";
        return first || last ? `${first} ${last}`.trim() : "N/A";
      },
    },

    //   {
    //     title: "Stage",
    //     dataIndex: "stage",
    //     showSorterTooltip: { target: "full-header" },
    //     filters: [
    //       ...new Set(dealsData.map((deal) => deal.dealStage).filter(Boolean)),
    //     ].map((dealStage) => ({
    //       text: dealStage,
    //       value: dealStage,
    //     })),
    //   //   onFilter: (value, record) => record.dealStage === value,
    //     key: "stage",
    //     render: (record, text) => text?.dealStage || "Not Available",
    //   },
  ];

  return (
    <>
      <Container>
        <ToastContainer></ToastContainer>


        <div className={styles["search-container"]}>
                  <Input allowClear placeholder="Search by name or address" onChange={(e) => setSearchQuery(e.target.value)} />

                  <Select 
                  placeholder="Filter with status"
                  onChange={(value) => setfilters(value)}
                  options={
                    [
                    // { value: 1, label: "Deals with Bids" },
                    // { value: 2, label: "Deals without Bids" },
                    { lable: "Not started", value: "Not started" },
                    { label: "In Progress", value: "In Progress" },
                    { label: "Pre Live", value: "Pre Live" },
                    { label: "Live", value: "Live" },
                  ]
                  }
                  allowClear
                  style={{ width: 400 }}
                  />
                    
                  <Button color="#18365e" style={{ backgroundColor: "#18365e", color: "white" }} onClick={() => handleSearch()}>Filter</Button>

                  <Button
                    icon={<SyncOutlined />}
                    loading={isSyncLoading}
                    onClick={() => syncSites()}
                  >
                    {isSyncLoading ? "Syncing..." : "Sync Sites"}
                  </Button>
                </div>



        
        {isApprover && <Button onClick={()=>{
          setIsApproverView(true)
        }}>Pending Site For Approval</Button> }
        {isApprover && <Button onClick={()=>{
          setIsApproverView(false)
        }}>All site Data</Button>}
        <Table
          loading={isLoading}
          pagination={pagination}
          bordered
          onChange={handleTableChange}
          columns={column}
          dataSource={siteTrackerData}
          rowKey={"_id"}
        />
      </Container>

      {showSiteTrackerDetails && (

        <Drawer
                title={<>{selectedSite?.name || "Site Details"} <span style={{ marginLeft: '10px' }}>{autoSaveInprogress && (<><LoadingOutlined spin /> Auto Save Inprogress...</>)}</span>
                                    {/* <span>{selectedSite?.status}</span>  */}
                                    </>}
                  open={showSiteTrackerDetails}
                  placement="right"
                  closable={true}
                  onClose={() => {
                    setSiteTrackerData([]);
                    setShowSiteTrackerDetails(false);
            setSelectedSite(null);
                  }}
                  width={"65%"}
                >
                    <SiteTrackerDetails selectedSite={selectedSite} autoSaveInprogress={autoSaveInprogress} setAutoSaveInprogress={setAutoSaveInprogress} isApprover={isApprover} isApproverView={isApproverView} showSiteTrackerDetails={showSiteTrackerDetails} setShowSiteTrackerDetails={setShowSiteTrackerDetails}/>
                </Drawer>
        // <Modal
        //   open={showSiteTrackerDetails}
        //   onCancel={() => {
        //     setShowSiteTrackerDetails(false);
        //     setSelectedSite(null);
        //   }}
        //   footer={null}
        //   centered
        // >
        //   <SiteTrackerDetails selectedSite={selectedSite}></SiteTrackerDetails>
        // </Modal>
      )}
      
    </>
  );
};

// export default SiteInstallAndOnboarding;


SiteInstallAndOnboarding.propTypes = {
  // user: PropTypes.string,
  // userID: PropTypes.string,
  userGroups: PropTypes.array,
  // phone: PropTypes.string,
  // email: PropTypes.string,
};
const mapStateToProps = (state) => ({
  // user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  // userID: state.auth && state.auth.user ? state.auth.user._id : null,
  userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
  // phone: state.auth && state.auth.user ? state.auth.user.phone : false,
  // email: state.auth && state.auth.user ? state.auth.user.email : false,
});
export default connect(mapStateToProps, {})(SiteInstallAndOnboarding);